import { buildMemberNameProps } from './utils'

const getMemberById =
  state =>
  ({ personId, channelPersonId }) => {
    const member = personId
      ? state.all[personId]
      : Object.values(state.all).find(
          member => member.channelPersonId === channelPersonId
        )
    if (!member) return

    return {
      ...member,
      ...buildMemberNameProps(member)
    }
  }

export default {
  getMemberById
}
